import {
  TicketSalePageEvent,
  TicketSubtype,
} from 'app/pages/TicketSalePage/slice/types';
import { buildPriceToShow, getFeePrice, getTaxPrice } from './tickets';

const getSubtypesPriceRange = (subtypes: TicketSubtype[]) => {
  const prices = subtypes.map(subtype => subtype.price);
  return {
    min: Math.min(...prices),
    max: Math.max(...prices),
  };
};

export const getFormattedSubtypesPriceRange = (
  event: TicketSalePageEvent,
  subtypes: TicketSubtype[],
  currency: string,
) => {
  const { min, max } = getSubtypesPriceRange(subtypes);

  if (min === max) {
    return buildPriceToShow(getApplicablePrice(event, min), currency);
  }

  return `${buildPriceToShow(
    getApplicablePrice(event, min),
    currency,
  )} - ${buildPriceToShow(getApplicablePrice(event, max), currency)}`;
};

const getApplicablePrice = (event: TicketSalePageEvent, price: number) => {
  let result = price;

  if (event.tax_included) {
    result += getTaxPrice(result, event.tax_rate.rate);
  }

  if (event.fee_included) {
    const theFeePaidForASingleTicket = getFeePrice(price, event.fees);
    result += theFeePaidForASingleTicket;
  }

  return result;
};
